/* global axios */
export default class CancellationService {
  constructor() {
    this.axios = axios;
  }
  save(formData) {
    return this.axios.post('service/cancellation/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}
